<template>
  <div class="one-layer__body">
    <div class="child__anchor">
      <div class="child__body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
// Interface Delcaration
// <OneLayer center bottom> // Layer의 크기
//   <div id="three" style="border: 1px solid black" center bottom></div> // Layer안의 컴포넌트의 크기
// </OneLayer>

// OneLayer는 기본적으로 LayerStack의 width 100%, height 100%로 설정한다
// 포지션은 상관없다

// 하지만 크기를 변경하게 되면 포지션이 변경되어야 한다
// 상위 컴포넌트에서 <OneLayer width="100px" height="100px" bottom right> 이런식으로

// Layer안의 child는 template에서 가져와서 설정한다
// 여기도 마찬가지로 기본은 100%씩이다.

// Example
// <div class="layer__background" style="background-color: yellow" width="50%" height="50%" center></div>;

// <div style="background-color: brown" center right width="600px" height="400px"></div>

const extractAllAttributes = (el) => {
  const attrs = el.attributes;

  const result = {};
  for (let i = 0; i < attrs.length; i++) {
    const attr = attrs[i];
    result[attr.name] = attr.value;
  }

  return Object.keys(result).filter((key) => ["bottom", "top", "center", "right", "left"].includes(key));
};

export default {
  mounted() {
    // LayerStack과 OneLayer와의 관계
    // const isTop = this.hasAttribute("top");
    // if (isTop) this.$el.setAttribute("top", "0px");

    // const isBottom = this.hasAttribute("bottom");
    // if (isBottom) this.$el.setAttribute("bottom", "0px");

    // OneLayer와 Template과의 관계
    const templateEl = this.$slots.default[0].elm;

    const positionAttrs = extractAllAttributes(templateEl);

    const targetEl = this.$el.querySelector(".child__body");

    if (positionAttrs.length === 1 && positionAttrs[0] === "center") {
      targetEl.style.top = "50%";
      targetEl.style.left = "50%";
      targetEl.style.transform = "translate(-50%, -50%)";
    } else if (positionAttrs.length === 2) {
      if (positionAttrs.includes("top")) targetEl.style.top = "0px";
      if (positionAttrs.includes("bottom")) targetEl.style.bottom = "0px";
      if (positionAttrs.includes("left")) targetEl.style.left = "0px";
      if (positionAttrs.includes("right")) targetEl.style.right = "0px";

      if (positionAttrs.includes("center")) {
        if (positionAttrs.includes("top") || positionAttrs.includes("bottom")) {
          targetEl.style.left = "50%";
          targetEl.style.transform = "translate(-50%, 0%)";
        } else if (positionAttrs.includes("left") || positionAttrs.includes("right")) {
          targetEl.style.top = "50%";
          targetEl.style.transform = "translate(0%, -50%)";
        }
      }
    }

    // For fit-content
    // 중간에 child__body가 있어서 width:100%가 안먹어서 이렇게 해줘야 함

    templateEl.style.width = "100%";
    templateEl.style.height = "100%";

    const width = templateEl.getAttribute("width");
    const height = templateEl.getAttribute("height");

    if (width) targetEl.style.width = width;
    if (height) targetEl.style.height = height;
  },
};
</script>

<style scoped>
.one-layer__body {
  position: absolute;

  width: 100%;
  height: 100%;
}

.child__anchor {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100%;
}

.child__body {
  position: absolute;
}
</style>
